/**
 * Lets the current session frame consume the back button press before the
 * session steps back — e.g. the challenge step returns from its reminders to
 * its proposal instead of leaving the step.
 */
type Interceptor = () => boolean;

const stack: Interceptor[] = [];

export const registerBackInterceptor = (interceptor: Interceptor) => {
  stack.push(interceptor);
  return () => {
    const index = stack.indexOf(interceptor);
    if (index !== -1) {
      stack.splice(index, 1);
    }
  };
};

/**
 * true when the press was consumed by one of the registered frames.
 *
 * The whole stack is walked from the innermost registration outwards: a frame
 * and its container both register (React flushes child effects before parent
 * ones, so the container ends up on top), and an interceptor that declines the
 * press must not hide the ones below it.
 */
export const consumeBackPress = (): boolean => {
  for (let index = stack.length - 1; index >= 0; index--) {
    if (stack[index]()) {
      return true;
    }
  }
  return false;
};
